import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';
import { TState } from '~/src/store';

export const getSubscriptionsSummary = (state: TState) => {
    const currentTariff = selectCurrentTariff(state);

    if (currentTariff?.subscriptionsSummary) {
        const activeSubscriptions = currentTariff.subscriptionsSummary.map((item)=>{
            if (item.alias === currentTariff.alias) {
                return { ...item, active: true };
            }
            return { ...item, active: false };
        });

        const currentVariant = currentTariff?.subscriptionsSummary.findIndex(item => item.alias === currentTariff.alias);
        const hasNext = currentTariff.subscriptionsSummary[currentVariant + 1];
        const nextStep = currentTariff.subscriptionsSummary[hasNext ? currentVariant + 1 : currentVariant];

        return {
            subscriptionsSummary: activeSubscriptions,
            nextStep: nextStep,
            isLast: !hasNext,
        };
    }
    return null;
};
